import { ApiAppConfiguration } from '../api/azureFunctions/appConfiguration/appConfiguration.api';
import { storeAppConfiguration } from '../redux';
const apiAppConfiguration = new ApiAppConfiguration();

export const getAppKeyValuePairs = async (): Promise<boolean> => {
  return apiAppConfiguration
    .getKeyValuePairs()
    .then(response => {
      storeAppConfiguration(response);
      return true;
    })
    .catch(error => {
      console.log('APP CONFIGURATION ERROR', error);
      return false;
    });
};
